import type { ThemeConfig } from 'antd'
export const antdTheme: ThemeConfig = {
  token: {
    // Primary color
    colorPrimary: '#101C42',
    colorPrimaryHover: '#1A2A5E',
    colorPrimaryActive: '#0B132A',

    // Secondary colors
    colorSuccess: '#D2E697',
    colorSuccessHover: '#C2DD71',
    colorSuccessActive: '#B2D44B',

    // Tertiary colors
    colorInfo: '#2B4D4C',
    colorInfoHover: '#476F67',
    colorInfoActive: '#233E3D',

    // Accent colors
    colorWarning: '#D18F0D',
    colorWarningHover: '#E9A527',
    colorWarningActive: '#A6720A',

    // Error/Validation colors
    colorError: '#F1846A',
    colorErrorHover: '#F39680',
    colorErrorActive: '#EF6F53',

    // Border radius
    borderRadius: 10,

    // Font
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

    // Component specific tokens
    controlHeight: 40,
    controlInteractiveSize: 16,

    // Link colors
    colorLink: '#101C42',
    colorLinkHover: '#1A2A5E',
    colorLinkActive: '#0B132A',

    // Border colors
    colorBorder: '#D1DBD9',
    colorBorderSecondary: '#E8EDEC',

    // Background colors
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgLayout: '#F7FAEF',

    // Text colors
    colorText: '#101C42',
    colorTextSecondary: '#475F83',
    colorTextTertiary: '#75938D',
    colorTextQuaternary: '#A3B7B3',

    // Box shadow
    boxShadow:
      '0 1px 3px 0 rgba(43, 77, 76, 0.1), 0 1px 2px 0 rgba(43, 77, 76, 0.06)',
    boxShadowSecondary:
      '0 10px 15px -3px rgba(43, 77, 76, 0.1), 0 4px 6px -2px rgba(43, 77, 76, 0.05)'
  },
  components: {
    Button: {
      // Primary button styles
      primaryColor: '#FFFFFF',
      primaryShadow: '0 1px 3px 0 rgba(43, 77, 76, 0.1)',

      // Button padding
      paddingContentHorizontal: 16,
      paddingContentVertical: 8,

      // Border radius
      borderRadius: 10,

      // Font weight
      fontWeight: 500,

      // Default button styles
      defaultBorderColor: '#E3E4E5',
      defaultColor: '#101C42',
      defaultBg: '#ffffff',
      defaultHoverBorderColor: '#1A2A5E',
      defaultHoverColor: '#1A2A5E',
      defaultHoverBg: '#F7FAEF',
      defaultActiveColor: '#0B132A',
      defaultActiveBorderColor: '#0B132A',

      // Ghost button
      ghostBg: 'transparent',
      // Text button
      textHoverBg: 'rgba(16, 28, 66, 0.05)'
    },
    Input: {
      borderRadius: 10,
      paddingBlock: 8,
      paddingInline: 16,
      colorBorder: '#D1DBD9',
      colorBgContainer: '#FFFFFF',
      activeBorderColor: '#101C42',
      hoverBorderColor: '#1A2A5E',
      activeShadow: '0 0 0 2px rgba(43, 77, 76, 0.1)'
    },
    Select: {
      borderRadius: 10,
      controlPaddingHorizontal: 16,
      controlHeight: 40
    },
    Card: {
      borderRadius: 10,
      boxShadow:
        '0 1px 3px 0 rgba(43, 77, 76, 0.1), 0 1px 2px 0 rgba(43, 77, 76, 0.06)',
      paddingLG: 24
    },
    Modal: {
      borderRadius: 10
    },
    Drawer: {
      borderRadius: 10
    },
    Table: {
      borderRadius: 10,
      headerBg: '#F7FAEF',
      headerColor: '#101C42',
      rowHoverBg: '#F7FAEF'
    },
    Menu: {
      borderRadius: 10,
      itemSelectedBg: '#E8EDEC',
      itemSelectedColor: '#101C42',
      itemHoverBg: '#F7FAEF',
      itemHoverColor: '#101C42'
    },
    Tabs: {
      borderRadius: 10,
      itemSelectedColor: '#101C42',
      itemHoverColor: '#1A2A5E',
      inkBarColor: '#101C42'
    },
    Alert: {
      borderRadius: 10,
      defaultPadding: '12px 16px'
    },
    Message: {
      borderRadius: 10
    },
    Notification: {
      borderRadius: 10
    },
    Badge: {
      borderRadius: 10
    },
    Tag: {
      borderRadius: 10,
      defaultBg: '#F7FAEF',
      defaultColor: '#101C42'
    },
    Progress: {
      borderRadius: 10,
      remainingColor: '#E8EDEC'
    },
    Checkbox: {
      borderRadius: 4
    },
    Radio: {
      borderRadius: 999
    },
    Switch: {
      colorPrimary: '#101C42',
      colorPrimaryHover: '#1A2A5E'
    },
    DatePicker: {
      borderRadius: 10
    },
    Pagination: {
      borderRadius: 10,
      itemActiveBg: '#101C42',
      itemActiveBgDisabled: '#E8EDEC',
      itemActiveColorDisabled: '#A3B7B3',
      itemBg: '#FFFFFF',
      itemLinkBg: '#FFFFFF',
      itemInputBg: '#FFFFFF',
      colorText: '#101C42',
      colorTextDisabled: '#A3B7B3',
      colorPrimary: '#FFFFFF',
      colorPrimaryHover: '#FFFFFF',
      colorBgTextHover: '#F7FAEF',
      colorTextPlaceholder: '#75938D'
    },
    Breadcrumb: {
      lastItemColor: '#101C42',
      linkColor: '#75938D',
      linkHoverColor: '#1A2A5E',
      separatorColor: '#A3B7B3'
    },
    Dropdown: {
      borderRadius: 10
    },
    Steps: {
      colorPrimary: '#101C42',
      colorText: '#75938D'
    },
    Upload: {
      borderRadius: 10
    },
    Form: {
      labelColor: '#101C42',
      labelFontSize: 14,
      labelHeight: 22,
      itemMarginBottom: 24
    },
    Layout: {
      headerBg: '#101C42',
      headerColor: '#FFFFFF',
      siderBg: '#FFFFFF',
      bodyBg: '#F7FAEF',
      footerBg: '#101C42'
    }
  }
}
